export default class SideComponent {
  title: string = "";
  args: any = {};
}
